import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 16 16",
  "aria-hidden": "true"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      "fill-rule": "evenodd",
      d: "M5.304 3.304a.04.04 0 0 1 .03-.012h1.333a.04.04 0 0 1 .041.041V6a.04.04 0 0 1-.041.042H5.333A.04.04 0 0 1 5.292 6V3.333q0-.016.012-.03m2.654 1.988V6a1.29 1.29 0 0 1-1.291 1.292H5.333A1.29 1.29 0 0 1 4.042 6v-.708H2a.625.625 0 1 1 0-1.25h2.042v-.709a1.29 1.29 0 0 1 1.291-1.291h1.334a1.29 1.29 0 0 1 1.291 1.291v.709H14a.625.625 0 1 1 0 1.25zM9.304 9.97a.04.04 0 0 1 .03-.013h1.333a.04.04 0 0 1 .041.042v2.667a.04.04 0 0 1-.041.041H9.333a.04.04 0 0 1-.041-.041V10q0-.017.012-.03m-1.262 2.696v-.709H2a.625.625 0 1 1 0-1.25h6.042V10a1.29 1.29 0 0 1 1.291-1.292h1.334A1.29 1.29 0 0 1 11.958 10v.708H14a.625.625 0 0 1 0 1.25h-2.042v.709a1.29 1.29 0 0 1-1.291 1.291H9.333a1.29 1.29 0 0 1-1.291-1.291",
      "clip-rule": "evenodd"
    }, null, -1)
  ])))
}
export default { render: render }